module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185927.ec8d9ef1.jpg";